import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Box, Heading, Link} from '@salesforce/retail-react-app/app/components/shared/ui'

const GAP_SIZE = 20 // Gap between items in pixels

const MoreToDiscover = ({discoverCategories, ...props}) => {
    let categories = []

    try {
        const parsed = JSON.parse(discoverCategories || '[]')
        categories = Array.isArray(parsed) ? parsed : []
    } catch (error) {
        console.error('Failed to parse discoverCategories:', error)
        categories = []
    }

    return (
        <Box {...props}>
            <Heading as="h3" fontSize={{base: 'md', lg: 'xl'}} mb={{base: '12px', lg: '24px'}}>
                <FormattedMessage
                    id="product_detail.more_to_discover.heading"
                    defaultMessage="More to Discover"
                />
            </Heading>
            {/* CSS scroll container with bleed effect */}
            <Box
                display="flex"
                gap={`${GAP_SIZE}px`}
                overflowX="auto"
                mx={{base: '-16px', lg: '-24px'}}
                pl={{base: '16px', lg: '24px'}}
                pr={{base: '16px', lg: '24px'}}
                sx={{
                    // Hide scrollbar across browsers
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    WebkitOverflowScrolling: 'touch',
                    '& > *': {
                        flexShrink: 0
                    }
                }}
            >
                {categories.map(({id, name, url}) => (
                    <Link
                        key={id}
                        fontSize={{base: 'sm', lg: 'md'}}
                        fontWeight={500}
                        href={url}
                        whiteSpace="nowrap"
                    >
                        {name}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export default MoreToDiscover
